import { create } from "zustand";
import { persist } from "zustand/middleware";
import { omit } from "lodash";

export interface SidebarStore {
  sidebarOpen: boolean;
  actions: {
    openSidebar: () => void;
    closeSidebar: () => void;
  };
}

const initialState: Omit<SidebarStore, "actions"> = {
  sidebarOpen: true,
};

const useSidebarStore = create<SidebarStore, [["zustand/persist", Omit<SidebarStore, "actions">]]>(
  persist(
    (set) => ({
      ...initialState,

      actions: {
        openSidebar: () => {
          set({ sidebarOpen: true });
        },
        closeSidebar: () => {
          set({ sidebarOpen: false });
        },
      },
    }),
    {
      name: "sidebar-store",
      version: 1,
      partialize: (state) => {
        return omit(state, ["actions"]);
      },
    }
  )
);

export default useSidebarStore;
